import { DocumentCategory } from './document-category.enum';

export const mapDocumentCategoryToState = {
    [DocumentCategory.incomes]: 'income',
    [DocumentCategory.identification]: 'identification',
    [DocumentCategory.financials]: 'financials',
    [DocumentCategory.properties]: 'properties'
};
